
import { mdiCheck } from '@mdi/js'

export default {
  mdiCheck,
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editedOptionLabel: this.option.label
    }
  }
}
